import { render } from "./ClientControlAccesoUsuarios.vue?vue&type=template&id=6665286c&scoped=true"
import script from "./ClientControlAccesoUsuarios.vue?vue&type=script&lang=js"
export * from "./ClientControlAccesoUsuarios.vue?vue&type=script&lang=js"

import "./ClientControlAccesoUsuarios.vue?vue&type=style&index=0&id=6665286c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6665286c"]])

export default __exports__